<template>
  <div
    id="rooms"
  >
    <div id="pdf-viewer" :class="{ open: pdfUrl }">
      <v-btn class="btn-close" icon @click.stop="pdfUrl = ''">
        <img src="/static/img/icons/close.svg" alt="close" class="close">
      </v-btn>
    <iframe :src="pdfUrl" frameborder="0"></iframe>
    </div>
    <v-container grid-list-md fluid>
      <v-layout row wrap class="main_layout_db">
        <v-flex d-flex xs12 md7 lg7>
          <v-card flat class="trbg rooms-card">
          <div>

            <div
                class="album-page"
            >
                <div
                  v-if="currAlbumPage"
                >
                  <img
                    :src="`https://www.mari-portal.de/omeka/files/album/${currAlbumPage.scan}_mittel.jpg`"
                    :alt="`Album Amicorum, Seite mit Widmung von ${currAlbumPage.name}`"
                    :tile="`Album Amicorum, Seite mit Widmung von ${currAlbumPage.name}`"
                  />
                </div>
                <div
                  v-else
                >
                  <img
                    :src="`https://www.mari-portal.de/omeka/files/album/00000005_mittel.jpg`"
                    :alt="`Album Amicorum, Titel`"
                    :tile="`Album Amicorum, Titel`"
                  />
                </div>
            </div>
          </div>
          </v-card>
        </v-flex>
        <v-flex d-flex xs12 md5 lg5>
          <v-card flat class="trbg rooms-card">
          <h1 class="album-title">{{ translate['Intro Album'][lang] }}</h1>
          <h3 class="album-sub-title">{{ translate['Sub Album'][lang] }}</h3>
          <div
            v-if="currAlbumPage"
            class="currently-shown"
          >
            {{ translate['Widmung von'][lang] }} <strong>{{ currAlbumPage.firstName }} {{ currAlbumPage.lastName }}</strong>
          </div>
          <div
            v-else
            class="currently-shown"
          >
            {{ translate['Titelseite Album'][lang] }}
          </div>
          <div

          >
            <h2
              v-html="translate['Widmungen'][lang]"
            />
            <div class="name-listing">
              <div
                v-for="(letter, index) in alphabet"
                :key="`letter-${index}`"
              >
                <LetterDisplay :letter="letter" />
              </div>
            </div>

          </div>
          <!-- <div
            class="catalog-source"
            style="border-top: 1px solid #ccc; padding: 1.2rem 0 .2rem 0;"
          >
            <div class="source-info">
              <h3>{{ translate['Quelle der Rekonstruktion'][lang] }}</h3>
              <p><a id="lnk_open" @click.prevent="showCatalog()" href="#">{{ translate['Katalog einsehen'][lang] }}</a></p>
            </div>
            <div class="catalog-thumb">
              <img
                :src="catalogThumb()"
                @click="showCatalog()"
              />
            </div>
          </div> -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// import Vue from 'vue'
// import BootstrapVue from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import LetterDisplay from '@/components/pages/partials/Letter-display.vue'

export default {
  name: 'Album',
  components: {
    LetterDisplay
  },
  computed: {
    ...mapGetters(['plans', 'roomListings', 'roomIds', 'roomPeriods', 'markers1908', 'translate', 'lang', 'album', 'currAlbumPage', 'oSharedObjects'])
    // roomDisplay () {
    //   return this.akRoomLabel
    // }
  },
  data () {
    return {
      alphabet: [ 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z' ],
      pdfUrl: '',
      // provisorische Jahresangaben
      provPeriods: [1900, 1908, 1912, 1913, 1915, 1921],
      akPeriod: 1908,
      akLevel: 'OG1',

      akRoomLabel: '',
      akRoomWorkList: []
    }
  },
  methods: {
    showCatalog () {
      // this.pdfUrl = this.roomPeriods.find(rp => rp.year === this.akPeriod).pdf
      this.pdfUrl = 'https://www.mari-portal.de/wp/wp-content/uploads/2024/04/Album_Amicorum_mittel.pdf'
    },
    catalogThumb () {
      return this.roomPeriods.find(rp => rp.year === this.akPeriod).thumb
    }
  },
  created () {
    this.$forceUpdate() // Notice we have to use a $ here
    // this.generateData()
  }
}
</script>
<style lang="scss" >
.rooms-card {
  padding: 1rem 1.4rem;
}
.plan-svg {
  position: relative;
}
.plan {
  background-color: #fff;
}
.marker {
  position: absolute;
}
.label {
  position: relative;
  max-width: 4rem;
  top: -2rem;
  left: -1.5rem;
  background-color: rgba(255,255,255,.4);
  padding: 1rem .6rem;
  font-size: .70rem;
  cursor: pointer;
}
.svg-container {
  position: relative;
}
.period-switch,
.level-switch {
  display: inline-block;
  margin: 0 .4rem 0 0;
}
.active-choice {
  font-weight: bold;
  cursor: default;
  font-family: 'Conv_ApercuPro-Bold';
  text-decoration: none;
  letter-spacing: 0.05rem;
  padding-bottom: .25rem;
}
.inactive-choice {
  font-weight: normal;
  cursor: pointer;
  font-family: 'Conv_ApercuPro-Bold';
  text-decoration: none;
  color: #6c07ff;
  letter-spacing: 0.05rem;
  padding-bottom: .25rem;
}
.work-listing {
  margin: .4rem 0;
  a,
  a:link,
  a:visited,
  a:focus {
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
}
.work-author {

}
.work-title {

}
.b-plans-row {
  margin-left: 0;
  height: 100%;
  margin-right: 0;
  max-width: unset;
}

.b-plans-row .content-row {
  height: 100%;
}

.b-plans-row .content-col {
  background-color: #ffffff;
  height: 100%;
  margin-right: 5px;
}
  .room-box {
    margin: 1rem 3rem;
    border: 1px solid green;
  }
  .period-box {
    display: inline-block;
    margin: 1rem;
    width: 25%;
  }
  #pdf-viewer {
  position: fixed;
  top: 50%;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  z-index: -1;
  background-color: rgba(0, 0, 0, .8);
  transition: all .5s;
  width: 100%;
  padding: 4rem 4rem 2rem;
  transform: scaleX(0);

  &.open {
    z-index: 1004;
    top: 0;
    opacity: 1;
    transform: scaleX(1);
  }

  .btn-close {
    width: 4rem;
    position: absolute;
    z-index: 1;
    right: 0;
    top: 1rem;

    .v-btn__content {
      &:before {
        content: none !important;
      }
    }
  }

  iframe {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
.catalog-source {
  display: flex;
  margin: 1.6rem 0;

  .source-info {
    flex: 1;
  }
  #lnk_open {
    display: inline-block;
    margin: 1.6rem 0;
    font-family: 'Conv_ApercuPro-Bold';
    text-decoration: none;
    color: #6c07ff;
    letter-spacing: 0.05rem;
    padding-bottom: .25rem;
    border-bottom: 3px solid #6c07ff;
  }
  .catalog-thumb {
    cursor: pointer;
    justify-content: start;
    display: block;
    max-width: 280px;
  }
}
.application .v-content h1.album-title {
  margin-bottom: .4rem;
}
h3.album-sub-title {
  margin-top: .4rem;
}
.name-listing {
  max-height: 40vh;
  overflow: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/Album.vue